import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-report-of-graduates-course',
  templateUrl: './report-of-graduates-course.component.html',
  styleUrls: ['./report-of-graduates-course.component.css']
})
export class ReportOfGraduatesCourseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
